module.exports = __webpack_public_path__ + "media/assets/img/notice-preview-ba8554f5dca5acfcc85f4936a2ddf8d5.png";